"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asap = require("./asap");

Object.keys(_asap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _asap[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/@react-dnd/asap/dist/cjs/node/index.js
// module id = 2905
// module chunks = 39